<template>
  <div class="ren-decoration-cp ren-decoration-cp-notice" :class="{ 'is-scrollable': scrollable }" :style="textStyle">
    <b :style="iconStyle">{{ iconText }}</b>
    <span>{{ text }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { booleanValue, stringValue } from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const text = computed(() => stringValue(props.component.props?.text, '暂无公告'))
const scrollable = computed(() => booleanValue(props.component.props?.scrollable, true))
const iconText = computed(() => {
  const value = stringValue(props.component.props?.icon, '公告').trim()
  if (!value || value === 'bell') return '公告'
  return value.length <= 2 ? value : value.slice(0, 1)
})
const textStyle = computed(() => {
  const color = stringValue(props.component.style?.textColor)
  return color ? { color } : undefined
})
const iconStyle = computed(() => {
  const color = stringValue(props.component.style?.iconColor)
  return color ? { color } : undefined
})
</script>

<style scoped>
.ren-decoration-cp-notice b {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 600;
  color: var(--ren-theme-primary);
}

.ren-decoration-cp-notice.is-scrollable span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
